import React, { useState } from "react";
import Topheader from "../Topheader";
import Mainmenu from "../Mainmenu";
import CoursesNavbar from "../CoursesNabbar";
import Couses from "../Couses";
import Footer from "../Footer";
import ChapterBox from "./ChapterBox";
import Noteswritten from "../Noteswritten";

export default function Computerscience() {
  const [selectedPdf, setSelectedPdf] = useState(null);

  // Use direct links instead of /preview (Google Drive restricts preview navigation)
  const chapters = [
    { no: 1, name: "Computer Networking , Telecommunication, Internet and Services", pdflink:"https://drive.google.com/uc?export=download&id=1tZVtcL1JAuCVa2TS7JN-ZZ1aTgFttmtB/preview"},
    { no: 2, name: "Ethical and social issues", pdflink:"https://drive.google.com/file/d/1C5FVKk2ppD9aqcmKdBPH7jKzTqKkTCtB/preview" },
    { no: 3, name: "Computer Security", pdflink:"https://drive.google.com/uc?export=download&id=1BWuhc5IujsdxFiesgGALcWOxvds_3JQj/preview" },
    { no: 4, name: "E-commerce", pdflink:"https://drive.google.com/uc?export=download&id=1zCbbq0weorZ8b9-oU9ixgMwGd1QcrEZh/preview" },
    { no: 5, name: "Contemporary Technology", pdflink:"https://drive.google.com/uc?export=download&id=1zMrfuOOK1GA3fubjOxBknXr_0TuMs8R/preview" },
    { no: 6, name: "Number System", pdflink:"" },
    { no: 7, name: "Database Management System : Microsoft Access", pdflink:"https://docs.google.com/document/d/1uukdeByg8qTfDGrKOPE_T-zRW5jAaejWRQPvA-HZYsY/preview" },
    { no: 8, name: "Control Statements and Library Function In QBASIC", pdflink:"https://drive.google.com/uc?export=download&id=1nXN7WmRZRKPZEK67_7qdEx6YFuiCAgPF/preview" },
    { no: 9, name: "Modular Programming in QBASIC", pdflink:"https://docs.google.com/document/d/1jmrnTrWIljzQX8qmCxado4eVesfJtjAc4ZPEsDh1Tc4/preview" },
    { no: 10, name: "File Handling in QBASIC", pdflink:"https://docs.google.com/document/d/1vWe589JM_Qr6jLTGTEdag26zK1LGrmaQPNkk_oBlCLI/preview" },
    { no: 11, name: "C Programming", pdflink:"" },
  ];

  return (
    <>
      {/* Header Section */}
      <div className="bg-slate-300 mt-5 pb-3 lg:pb-3 shadow-sm">
        <Noteswritten />
      </div>

      <div className="mt-3">
        <CoursesNavbar />
      </div>

      {/* Chapter List */}
      <div className="flex justify-center flex-wrap mt-5 gap-4">
        {chapters.map((chapter) => (
          <div
            key={chapter.no}
            onClick={() => chapter.pdflink && setSelectedPdf(chapter.pdflink)}
            className="cursor-pointer flex-1 min-w-[250px] max-w-[280px] flex"
          >
            <ChapterBox
              chapterNo={chapter.no}
              chapterName={chapter.name}
            />
          </div>
        ))}
      </div>

      {/* PDF Viewer Modal */}
      {selectedPdf && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 px-4">
          <div className="bg-white rounded-lg shadow-lg w-full md:w-4/5 h-[80vh] flex flex-col">
            
            {/* Close Button */}
            <div className="flex justify-end p-2">
              <button
                onClick={() => setSelectedPdf(null)}
                className="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 transition"
              >
                Close
              </button>
            </div>

            {/* PDF iframe */}
            <div className="flex-1">
              <iframe
                src={selectedPdf}
                className="w-full h-full border border-gray-300 rounded-b-lg"
                title="PDF Viewer"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      <div className="mt-[10px]">
        <Footer />
      </div>
    </>
  );
}
